import React, { Component } from 'react'
import { Toolbar, ToolbarGroup, ToolbarTitle } from 'material-ui/Toolbar';
import RaisedButton from 'material-ui/RaisedButton';
import { Card } from 'material-ui/Card';
import Divider from 'material-ui/Divider';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import _ from 'lodash';
import Pagination from 'materialui-pagination';

import * as DataAPI from "../../../common/DataAPI.js";
import UserDialog from './UserDialog';
import Dialogs from "../../../common/Dialogs.js";
import constants from "../../../common/constants.js";
import UserList from "./UserList.js"

class User extends Component {
  constructor() {
    super();
    this.state = {
      users: [],
      roles: [],
      userToDialog: null,
      shouldOpenUserDialog: false,
      filter: {
        userLoginId: '',
        userName: '',
      },
      rowsPerPage: [5, 10, 15],
      rows: [],
      numberOfRows: 5,
      page: 1,
      totalNoOfUsers: undefined,

    };

    this.openUserDialogToEdit = this.openUserDialogToEdit.bind(this);
    this.openUserDialog = this.openUserDialog.bind(this);
    this.closeUserDialog = this.closeUserDialog.bind(this);
    this.submitUser = this.submitUser.bind(this);
    this.updateUserState = this.updateUserState.bind(this);
    this.addUser = this.addUser.bind(this);
    this.deleteUser = this.deleteUser.bind(this);
    this.saveUser = this.saveUser.bind(this);
    this.updateFilterState = this.updateFilterState.bind(this);

    this.updateUsers = this.updateUsers.bind(this);
  }

  componentWillMount() {
    this.refreshUserList();
    this.fetchRoleList();
  }

  refreshUserList() {
    this.fetchUserList({
      page: this.state.page,
      noOfRecords: this.state.numberOfRows,
      loginId: this.state.filter.userLoginId,
      name: this.state.filter.userName,
    }, (err, result) => {
      if (err) return this.dialogs.error(err);

      const { totalNoOfUsers, users } = result;

      this.setState({
        totalNoOfUsers,
        users,
      });
    });
  }

  openUserDialog() {
    this.setState({
      shouldOpenUserDialog: true,
    });
  }

  closeUserDialog() {
    this.setState({
      shouldOpenUserDialog: false,
    });
  }

  addUser() {
    this.setState({
      userToDialog: {
        loginId: '',
        password: '',
        name: '',
        status: 'active',
      },
    }, () => {
      this.openUserDialog();
    })
  }

  submitUser(user) {
    // let scheduleToShow = { ...this.state.advPositionSelected.scheduleToShow };
    //
    // let photosToUpdate = _.concat(scheduleToShow[schedulingIndex].user, photos);
    // this.updateScheduleToShow(schedulingIndex, 'photos', photosToUpdate);
    if (user._id) {
      // if (!_.size(user.photo)) _.set(user, 'photo', null);

      this.updateUser({ user }, (err) => {
        if (err) return this.dialogs.error(err);

        this.dialogs.alert({
          title: '成功更新用戶',
        });
        this.refreshUserList();
        this.closeUserDialog();
      });
    } else {
      // if (!_.size(user.photo)) _.unset(user, 'photo');

      this.saveUser({ user }, (err) => {
        if (err) return this.dialogs.error(err);

        this.dialogs.alert({
          title: '成功儲存用戶',
        });
        this.refreshUserList();
        this.closeUserDialog();
      });
    }
  }

  openUserDialogToEdit(userId) {
    const user = _.cloneDeep(_.find(this.state.users, { _id: userId }));

    this.setState({
      userToDialog: user,
    }, () => {
      this.openUserDialog();
    });
  }

  deleteUser(userId) {
    this.dialogs.confirm({
      title: '確認要刪除這用戶？',
    }, () => {
      DataAPI.delete(`/api/adminPanel/user/${userId}`, {}, (err) => {
        if (err) return this.dialogs.error(err);

        this.refreshUserList();
      });
    });
  }

  saveUser({ user }, cb = constants.emptyFnc) {
    DataAPI.put('/api/adminPanel/user', {
      user,
    }, cb)
  }

  fetchUserList({ page, noOfRecords, loginId, name }, cb) {
    const query = _.omitBy({
      page,
      noOfRecords,
      loginId,
      name,
    }, _.isNil);

    DataAPI.get('/api/adminPanel/users', query, cb);
  }

  fetchRoleList() {
    DataAPI.get('/api/adminPanel/roles', {}, (err, roles) => {
      if (err) return this.dialogs.error(err);

      this.setState({ roles });
    });
  }

  updateUserState(index, field, value) {
    let users = _.cloneDeep(this.state.users);

    _.set(users[index], field, value);

    this.setState({
      users,
    });
  }

  updateUser({ user }, cb = constants.emptyFnc) {
    DataAPI.post(`/api/adminPanel/user/${user._id}`, {
      user,
    }, cb);
  }

  updateUsers({ page, numberOfRows }) {
    this.setState({
      page,
      numberOfRows,
    }, () => {
      this.refreshUserList();
    })
  }

  updateFilterState(field, value) {
    console.log('field, value:', field, value);
    let filter = _.cloneDeep(this.state.filter);

    _.set(filter, field, value);

    this.setState({
      filter,
    }, () => {
      this.setState({
        page: 1,
      }, this.refreshUserList);
    });
  }

  render() {
    const wrapOnChange = (fnc, field, event, value) => {
      fnc(field, value);
    };

    const wrapSelecFieldtOnChange = (fnc, field, event, index, value) => {
      fnc(field, value);
    };

    return (
      <div>
        <Toolbar>
          <ToolbarGroup>
            <ToolbarTitle
              text="用戶管理" />
          </ToolbarGroup>
          <ToolbarGroup
            lastChild={true}>
            <RaisedButton
              label="新增用戶"
              primary={true}
              icon={<i className="material-icons md-light">add</i>}
              onClick={this.addUser} />
          </ToolbarGroup>
        </Toolbar>

        <TextField
          style={{
            top: -15,
            marginLeft: 10,
          }}
          floatingLabelText="ID"
          value={_.get(this.state.filter, 'userLoginId')}
          onChange={wrapOnChange.bind(this, this.updateFilterState, 'userLoginId')}
          type="text"
        />

        <TextField
          style={{
            top: -15,
            marginLeft: 10,
          }}
          floatingLabelText="名稱"
          value={_.get(this.state.filter, 'userName')}
          onChange={wrapOnChange.bind(this, this.updateFilterState, 'userName')}
          type="text"
        />

        <UserList
          users={this.state.users}
          roles={this.state.roles}
          onEdit={this.openUserDialogToEdit}
          onDelete={this.deleteUser} />
        <Divider />
        <Pagination
          total={this.state.totalNoOfUsers}
          rowsPerPage={this.state.rowsPerPage}
          page={this.state.page}
          numberOfRows={this.state.numberOfRows}
          updateRows={this.updateUsers}
        />
        <UserDialog
          open={this.state.shouldOpenUserDialog}
          user={this.state.userToDialog}
          roles={this.state.roles}
          handleClose={this.closeUserDialog}
          handleSubmit={this.submitUser} />
        <Dialogs onInit={dialog => (this.dialogs = dialog)} />
      </div>
    )
  }
}

export default User;


// WEBPACK FOOTER //
// client/adminPanel/panel/users/User.js